export const PARTNER_MODES = {
    MAIN_TABLE: 'MainTable',
    ADD: 'Add',
    EDIT: 'Edit',
    APPROVAL: 'Approval',
    DELETE: 'Delete',
    CHANGE_LOGO: 'Change Logo',
    LOADING: 'Loading',
};

export const INITIAL_PARTNER_DATA = {
    name: '',
    entityName: '',
    hostHeader: '',
    defaultPartnerPlanID: null,
    defaultPartnerPlan: null,
    wholesalerID: '',
    status: 0,
    isActive: true,
    enabled: true,
    isTrial: false,
    trialEnd: null,
    trialEndLocal: null,
    trialHold: false,
    trialCallLimit: 0,
    callCounter: 0,
    trunkLocationID: 'MEL', // Default trunk location for partners
    pAttribute1: null,
    pAttribute2: null,
    pAttribute3: null,
    pServiceCountries: null,
    primaryContactName: null,
    primaryContactEmail: null,
    primaryContactPhone: null,
    accountsContactEmail: null,
    supportContactEmail: null,
    businessNumber: null,
    visibilityGroupID: null,
    visibilityGroupName: '',
    regions: [],
    voicePolicies: [],
    plans: [],
    partnerBillingSettings: {
        billingNotes: [],
    },
    partnerBranding: {
        defaultBillingDay: 0,
    },
};

export const FORM_FIELD_PATHS = {
    // Basic Partner Fields
    NAME: 'name',
    ENTITY_NAME: 'entityName',
    HOST_HEADER: 'hostHeader',
    DEFAULT_PARTNER_PLAN_ID: 'defaultPartnerPlanID',
    DEFAULT_PARTNER_PLAN: 'defaultPartnerPlan',
    WHOLESALER_ID: 'wholesalerID',
    STATUS: 'status',
    IS_ACTIVE: 'isActive',
    ENABLED: 'enabled',
    TRUNK_LOCATION_ID: 'trunkLocationID',

    // Trial Fields
    IS_TRIAL: 'isTrial',
    TRIAL_END: 'trialEnd',
    TRIAL_END_LOCAL: 'trialEndLocal',
    TRIAL_HOLD: 'trialHold',
    TRIAL_CALL_LIMIT: 'trialCallLimit',
    CALL_COUNTER: 'callCounter',

    // Contact Fields
    PRIMARY_CONTACT_NAME: 'primaryContactName',
    PRIMARY_CONTACT_EMAIL: 'primaryContactEmail',
    PRIMARY_CONTACT_PHONE: 'primaryContactPhone',
    ACCOUNTS_CONTACT_EMAIL: 'accountsContactEmail',
    SUPPORT_CONTACT_EMAIL: 'supportContactEmail',
    BUSINESS_NUMBER: 'businessNumber',

    // Partner Custom Attributes
    P_ATTRIBUTE_1: 'pAttribute1',
    P_ATTRIBUTE_2: 'pAttribute2',
    P_ATTRIBUTE_3: 'pAttribute3',
    P_SERVICE_COUNTRIES: 'pServiceCountries',

    // Partner Billing Settings
    BILLING_SETTINGS: 'partnerBillingSettings',
    BILLING_DAY: 'partnerBillingSettings.billingDay',
    DEFAULT_COMPANY_BILLING_DAY: 'partnerBranding.defaultBillingDay',
    BILL_TO: 'partnerBillingSettings.billTo',
    PER_NUMBER_PLAN: 'partnerBillingSettings.perNumberPlan',
    ALLOW_PLANS_PER_NUMBER: 'partnerBillingSettings.perNumberPlan',
    SURCHARGE: 'partnerBillingSettings.surcharge',
    SURCHARGE_TYPE: 'partnerBillingSettings.surchargeType',
    LEAD_IN_PRORATA: 'partnerBillingSettings.leadInProrata',
    PROCESS_BILLING: 'partnerBillingSettings.processBilling',
    OMIT_NUMBER_BLOCKS: 'partnerBillingSettings.omitNumberBlocks',
    BILL_ONE_LINE: 'partnerBillingSettings.billOneLine',
    BILL_SHOW_CDR: 'partnerBillingSettings.billShowCDR',
    BILL_SHOW_USERS: 'partnerBillingSettings.billShowUsers',
    BILL_SHOW_RGS: 'partnerBillingSettings.billShowRGS',
    BILL_SHOW_COMPANY: 'partnerBillingSettings.billShowCompany',
    BILL_SHOW_ZERO: 'partnerBillingSettings.billShowZero',
    BILL_SHOW_TRUNK: 'partnerBillingSettings.billShowTrunk',
    BILL_SHOW_NUMBER_BLOCK: 'partnerBillingSettings.billShowNumberBlock',
    BILLING_NOTES: 'partnerBillingSettings.billingNotes',
    MIN_USER_COUNT: 'partnerBillingSettings.minBillableUsers',
    MIN_RESOURCE_ACCOUNT_COUNT:
        'partnerBillingSettings.minBillableResourceAccounts',
    TRACKING_NAME_2: 'partnerBillingSettings.trackingName2',
    TRACKING_OPTION_2: 'partnerBillingSettings.trackingOption2',

    // Other Fields
    REGIONS: 'regions',
    VOICE_POLICIES: 'voicePolicies',
    PLANS: 'plans',
    VISIBILITY_GROUP_ID: 'visibilityGroupID',
    VISIBILITY_GROUP_NAME: 'visibilityGroupName',
};

export { invoiceFormatList } from 'pages/organisations/sharedComponents/constants';
